import Helper from "@ember/component/helper"

export function gt(params) {
  let first = params[0]
  let second = params[1]
  return first > second
}

export default class Gt extends Helper {
  compute = gt
}
